import LoadingSpinner from "../LoadingSpinner";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../tailwind/table";
import { api } from "../../api";
import { useFindMany } from "@gadgetinc/react";
import { Link } from "../tailwind/link";
import { SegmentFiltersTooltip } from "../SegmentFiltersTooltip";

export function SendingListFuture({ campaign }) {
  const [{ data: dataFuture, fetching: fetchingFuture }] = useFindMany(
    api.sending,
    {
      filter: [
        {
          status: { equals: "registered" },
        },
        {
          campaignId: { equals: campaign },
        },
      ],
      select: {
        id: true,
        contactList: true,
        sendingDate: true,
        contactListSegment: {
          externalId: true,
          type: true,
        },
        segment: {
          id: true,
          name: true,
        },
        segmentFilters: true,
      },
      sort: {
        sendingDate: "Ascending",
      },
    },
  );

  return (
    <>
      {fetchingFuture && <LoadingSpinner />}
      {!fetchingFuture && (
        <Table className="mb-5">
          <TableHead>
            <TableRow>
              <TableHeader className="w-[30%]">Sending date</TableHeader>
              <TableHeader className="text-center">Recipients</TableHeader>
              {!campaign.automationType && (
                <TableHeader className="w-[60%]">Segment</TableHeader>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {dataFuture && dataFuture.length > 0 ? (
              dataFuture.map(
                ({
                  id,
                  contactList,
                  sendingDate,
                  contactListSegment,
                  segment,
                  segmentFilters,
                }) => (
                  <TableRow id={id} key={id}>
                    <TableCell className="w-[60%]">
                      {new Date(sendingDate).toLocaleDateString("en-US", {
                        weekday: "short",
                        month: "short",
                        day: "numeric",
                        hour: "numeric",
                        minute: "numeric",
                      })}
                    </TableCell>
                    <TableCell className="text-center">
                      {contactList.length}
                    </TableCell>

                    {!campaign.automationType && (
                      <TableCell className="w-[60%]">
                        {segment ? (
                          <SegmentFiltersTooltip
                            segmentFilters={segmentFilters}
                          >
                            <span className="cursor-help">{segment.name}</span>
                          </SegmentFiltersTooltip>
                        ) : contactListSegment?.type === "klaviyo-segment" ? (
                          <Link
                            style={{
                              wordBreak: "break-all",
                              overflowWrap: "break-word",
                            }}
                            className="hover:underline"
                            href={`https://www.klaviyo.com/list/${contactListSegment?.externalId}`}
                            target="_blank"
                          >
                            {`https://www.klaviyo.com/list/${contactListSegment?.externalId}`}
                          </Link>
                        ) : (
                          "-"
                        )}
                      </TableCell>
                    )}
                  </TableRow>
                ),
              )
            ) : (
              <TableRow>
                <TableCell colSpan={2} className="text-center">
                  No scheduled sendings
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      )}
    </>
  );
}
